// extracted by mini-css-extract-plugin
export default {"heading":"CategoryFilter_heading__2KryO","text":"CategoryFilter_text__VF2Z5","edit-position-btn":"CategoryFilter_edit-position-btn__c5Ds4","row":"CategoryFilter_row__4vhr-"};